import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=3f2ad040&scoped=true"
import script from "./change-password.vue?vue&type=script&setup=true&lang=js"
export * from "./change-password.vue?vue&type=script&setup=true&lang=js"
import style0 from "./change-password.vue?vue&type=style&index=0&id=3f2ad040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ad040",
  null
  
)

export default component.exports